// extracted by mini-css-extract-plugin
module.exports = {"container":"student_container__CvEOq","title":"student_title__1uXsF","content":"student_content__cokxB","notes":"student_notes__2pZWu"};